/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FileImportantIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'File Important',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M19 14a1 1 0 0 1-1-1V2H7a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V14Zm-8.763-2.172a.362.362 0 0 1 .171-.373 5.889 5.889 0 0 1 2.035-.408 6.662 6.662 0 0 1 2.071.306.424.424 0 0 1 .2.374v2.443a78.132 78.132 0 0 1-.679 7.884c0 .1-.033.2-.237.2h-2.711a.224.224 0 0 1-.237-.2c-.069-.951-.612-4.931-.612-7.782Zm2.206 18.6a2.635 2.635 0 0 1-2.9-2.7 2.739 2.739 0 0 1 2.9-2.777 2.7 2.7 0 0 1 2.9 2.777 2.635 2.635 0 0 1-2.9 2.701Z"
    />
    <path d="M20 2v10h10L20 2z" />
  </svg>`;
};
